// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"109":"component---src-templates-home-tsx","453":"component---src-pages-404-tsx","667":"component---src-templates-legal-tsx"}[chunkId] || chunkId) + "-" + {"109":"48ef40cdbc4a0d492941","453":"2224069138eaad6302c1","454":"b31ede3c993bbaaa3490","667":"74ce87a8552f537f0821"}[chunkId] + ".js";
};